export type UIIconName =
  | "BIN"
  | "BORDER"
  | "COLLECTIONS"
  | "DRAG-HANDLE"
  | "GPS"
  | "LABEL-DECORATION-NONE"
  | "LABEL-DECORATION-LINE"
  | "LABEL-DECORATION-BRACKET"
  | "LABEL-DECORATION-CORNER"
  | "LABEL-DECORATION-BORDER"
  | "LABEL-DECORATION-DOT"
  | "LINE-STYLE"
  | "MAP"
  | "PENCIL"
  | "POINT-STYLE"
  | "PROJECTS"
  | "FOLDER"
  | "REMOVE"
  | "SIZE"
  | "STATIC-LABELS"
  | "BACKDROP"
  | "TEMPLATES"
  | "USER"
  | "MAP-LABELS"
  | "CHEVRON-LEFT"
  | "CHEVRON-RIGHT"
  | "CHEVRON-UP"
  | "CHEVRON-DOWN"
  | "LINE-STYLE-SINGLE"
  | "LINE-STYLE-FLANKED"
  | "LINE-STYLE-TRANSLUCENT"
  | "TEXT-ALIGN-LEFT"
  | "TEXT-ALIGN-CENTER"
  | "TEXT-ALIGN-RIGHT"
  | "COPY"
  | "SIGN-IN"
  | "SIGN-OUT"
  | "MAIN-MENU"
  | "PLUS"
  | "CHECK"
  | "CHECK-UNCHECKED"
  | "BAG";

export type UIIconVariant = "REGULAR" | "HIGHLIGHTED" | "SELECTED" | "CONTRAST";

export const iconPath = (icon: UIIconName, variant: UIIconVariant) => {
  const path = "/icons/UI-ICONS/" + variant + "/UI-ICON-" + icon + ".png";
  return path;
};
